export default __webpack_public_path__ + "static/media/confirmAppointment.60ab7fb6.png";